var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"timer-style-page"},[_c('span',[_vm._v("\n    "+_vm._s(_vm._f("formatValue")(_vm.hours))+"h : "+_vm._s(_vm._f("formatValue")(_vm.minutes))+"m\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }